import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';

export interface ListCounterProps {
  count: number;
  totalCount?: number;
}

const Label = styled.span`
  ${tokens.text('subtitle3')};
  white-space: nowrap;
`;

export const ListCounter = ({ count, totalCount }: ListCounterProps): JSX.Element => {
  const { t } = useTranslation('feedback');
  if (totalCount === undefined || count === totalCount) {
    return <Label>{t('count-responses', { count })}</Label>;
  }

  return (
    <Label>{t('subcount-out-of-count-responses', { subcount: count, count: totalCount })}</Label>
  );
};
